import React from 'react';
import { Link } from '@tanstack/react-router';
export const CompareIntro = () => (<section className="mb-10">
        <div className="rounded-2xl border bg-muted/40 px-6 py-8 md:px-8">
            <div className="max-w-3xl">
                <h1 className="text-3xl md:text-4xl font-bold leading-tight">Compare Adora with other tools</h1>

                <p className="mt-3 text-muted-foreground">
                    Not all QR and link tools are built for the same purpose. This section compares{' '}
                    <Link to="/what-is-adora" className="text-primary hover:underline">
                        Adora Analytics
                    </Link>{' '}
                    with other platforms so you can choose the right tool based on
                    <strong> how you run campaigns</strong>, not just where links point.
                </p>

                <div className="mt-4 flex flex-wrap gap-2 text-xs text-muted-foreground">
                    <span className="rounded-full border px-3 py-1">Offline marketing</span>
                    <span className="rounded-full border px-3 py-1">QR codes</span>
                    <span className="rounded-full border px-3 py-1">Smart links</span>
                    <span className="rounded-full border px-3 py-1">Campaign analytics</span>
                </div>
            </div>
        </div>
    </section>);
CompareIntro.displayName = 'CompareIntro';
